/* eslint-disable perfectionist/sort-objects */
// Teammates page toaster messages
export const TEAMMATES_MESSAGES = {
  UPDATED_INVITATION: 'Your invited teammates’ details have been updated.',
  REMOVED_INVITATION: 'Selected invitation has been removed.',

  UPDATED_ONBOARDED: 'Your onboarded teammate’s access has been updated.',
  REMOVED_ONBOARDED: 'Selected teammate has been removed.',
} as const;
